module.exports = __webpack_public_path__ + "static/img/11.3de8ab3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/eng/11.png
// module id = 07sC
// module chunks = 0